export interface PageFrom {
  pathname: string;
  search: string;
  label: string;
  /** Set when the place was opened from the header or home search. */
  reopenSearch?: string;
}

function fallbackBackLabel(pathname: string): string {
  if (pathname === '/' || pathname === '') return 'Back to Home';
  if (pathname === '/resources') return 'Back to Resources';
  if (pathname.startsWith('/resources/')) return 'Back to previous resource';
  if (pathname === '/resources' || pathname === '/toolkits' || pathname === '/references') {
    return 'Back to Resources';
  }
  if (pathname.startsWith('/toolkits/') || pathname.startsWith('/references/')) {
    return 'Back to previous place';
  }
  if (pathname === '/events') return 'Back to Events';
  if (pathname.startsWith('/events/')) return 'Back to previous event';
  if (pathname === '/dashboard') return 'Back to Home';
  return 'Back';
}

export function capturePageFrom(location: { pathname: string; search: string }): PageFrom {
  if (location.pathname === '/search') {
    return {
      pathname: location.pathname,
      search: location.search || '',
      label: 'Back to search',
    };
  }
  const title =
    typeof document !== 'undefined'
      ? document.title.replace(/\s*[|–—]\s*ORBCoN\s*$/i, '').trim()
      : '';
  const label =
    title && !/^ORBCoN\b/i.test(title) ? `Back to ${title}` : fallbackBackLabel(location.pathname);
  return {
    pathname: location.pathname,
    search: location.search || '',
    label,
  };
}

export function readPageFrom(state: unknown): PageFrom | null {
  if (!state || typeof state !== 'object') return null;
  const from = (state as { from?: PageFrom }).from;
  if (!from || typeof from.pathname !== 'string' || !from.pathname) return null;
  return {
    pathname: from.pathname,
    search: typeof from.search === 'string' ? from.search : '',
    label: typeof from.label === 'string' && from.label.trim() ? from.label : fallbackBackLabel(from.pathname),
    reopenSearch: typeof from.reopenSearch === 'string' && from.reopenSearch.trim()
      ? from.reopenSearch
      : undefined,
  };
}

export function readReopenSearch(state: unknown): string | null {
  if (!state || typeof state !== 'object') return null;
  const query = (state as { reopenSearch?: unknown }).reopenSearch;
  return typeof query === 'string' && query.trim() ? query : null;
}

export function reopenSearchState(from: PageFrom | null): { reopenSearch: string } | undefined {
  if (!from?.reopenSearch) return undefined;
  return { reopenSearch: from.reopenSearch };
}

export function pageFromTo(from: PageFrom): string {
  return `${from.pathname}${from.search || ''}`;
}
